// extracted by mini-css-extract-plugin
module.exports = {"searchbox":"CampusMapDining_searchbox__JLhMC","results__list":"CampusMapDining_results__list__3VeUH"};